<template>
  <div class="tradingview-widget-container tradingview-responsive mt-5">
    <div class="tradingview-widget-container__widget"></div>
    <div class="tradingview-widget-copyright">
      <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
        <span class="blue-text">Track all markets on TradingView</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "TradingChart",
  mounted() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.innerHTML = JSON.stringify({
      allow_symbol_change: true,
      calendar: false,
      details: false,
      hide_side_toolbar: true,
      hide_top_toolbar: false,
      hide_legend: false,
      hide_volume: false,
      hotlist: false,
      interval: "D",
      locale: "en",
      save_image: true,
      style: "1",
      symbol: "NASDAQ:AAPL",
      theme: "dark",
      timezone: "Etc/UTC",
      backgroundColor: "rgba(22, 35, 52, 1)",
      gridColor: "rgba(22, 35, 52, 0.06)",
      watchlist: [],
      withdateranges: false,
      compareSymbols: [],
      studies: [],
      autosize: true,
      height: 500,
      width: "100%"
    });
    this.$el.querySelector('.tradingview-widget-container__widget').appendChild(script);
  }
};
</script>
<style scoped>
.tradingview-responsive {
  width: 100%;
  max-width: 100%;
  height: 500px;
  min-height: 300px;
  box-sizing: border-box;
}
.tradingview-widget-container__widget {
  width: 100% !important;
  height: 100% !important;
}
</style>